export default __webpack_public_path__ + "static/media/et_r.4df7113d.png";